module.exports = __webpack_public_path__ + "img/logo_zalopay.62dbfcdf.png";